var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleCheckGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#4CB983"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6875 11.3125C23.0938 11.6875 23.0938 12.3438 22.6875 12.7188L14.6875 20.7188C14.3125 21.125 13.6562 21.125 13.2812 20.7188L9.28125 16.7188C8.875 16.3438 8.875 15.6875 9.28125 15.3125C9.65625 14.9062 10.3125 14.9062 10.6875 15.3125L13.9688 18.5938L21.2812 11.3125C21.6562 10.9062 22.3125 10.9062 22.6875 11.3125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheckGreen);
export default __webpack_public_path__ + "static/media/circle-check-green.9254bc9eebab4b4ad13fe19d788695c9.svg";
export { ForwardRef as ReactComponent };